
import { PuttSituation } from "@/types/golf";

export const liftedApproaches: PuttSituation = {
  id: 7,
  name: "Approches levées",
  image: "/lovable-uploads/9eeefcd9-ca34-4bb0-a86e-daa0530cba3b.png",
  description: "Sur le green d'approche ou sur le parcours choisissez un trou et matérialisez la position de départ de cette situation de jeu :\n-\tPlacer une marque au point A=15m disposée entre un bunker et un trou à 4 m maximum du bord de green. Jouez ensuite 10 balles successivement.",
  distances: [
    { point: "A", distance: 15, ballCount: 10 },
  ],
  scoring: [
    { condition: "Balle rentrée", points: 4 },
    { condition: "Balle à moins de 1m", points: 2 },
    { condition: "Balle entre 1m et 2m", points: 1 },
    { condition: "Balle au-delà de 2m", points: 0 },
  ],
  indexTable: [
    { points: 0, index: 37 },
    { points: 1, index: 32 },
    { points: 2, index: 27 },
    { points: 3, index: 23 },
    { points: 4, index: 19 },
    { points: 5, index: 16 },
    { points: 6, index: 13 },
    { points: 7, index: 10 },
    { points: 8, index: 7 },
    { points: 9, index: 4 },
    { points: 10, index: 1 },
    { points: 11, index: -2 },
    { points: 12, index: -4 },
    { points: 13, index: -6 },
    { points: 14, index: -8 },
  ],
};
